export const PROFILES = ['Jonathan', 'Emily', 'Slava', 'Mama + Papa'] as const;
export type Profile = (typeof PROFILES)[number];
export type MediaType = 'photo' | 'video';

export interface MediaItem {
  id: string;
  name: string;
  mediaType: MediaType;
  mimeType: string;
  size: number;
  capturedAt: string;
  uploadedAt: string;
  uploader: Profile;
  width?: number;
  height?: number;
  duration?: number;
  thumbnailUrl: string;
  contentUrl: string;
  downloadUrl: string;
}

export interface MediaPage {
  items: MediaItem[];
  nextCursor?: string;
}

export interface UploadFileRequest {
  clientId: string;
  name: string;
  mimeType: string;
  size: number;
  capturedAt: string;
  preview?: {
    mimeType: 'image/jpeg';
    size: number;
    width: number;
    height: number;
  };
}

export interface UploadAllocation {
  clientId: string;
  id: string;
  sessionUrl: string;
  preview?: {
    id: string;
    sessionUrl: string;
  };
}

export interface SessionPayload {
  profile: Profile;
  expiresAt: number;
  version: string;
}
